import { coverGradient, type Item } from "@instead/shared";

type CoverItem = Pick<Item, "coverKind" | "coverValue" | "coverSeed" | "coverUrl" | "thumbUrl" | "title">;

/** The one gradient every "no picture" surface uses (D-27), seeded per item. */
export function gradientStyle(seed: number): React.CSSProperties {
  const g = coverGradient(seed);
  return { background: `linear-gradient(${g.angle}deg, ${g.from}, ${g.to})` };
}

/**
 * Every item picture, everywhere, is 16:9 (round 1): stored image, source
 * thumbnail, emoji on a gradient, short text on a gradient, or the gradient
 * alone. `size` only changes the type scale; the box scales with its parent.
 */
export function Cover({ item, className = "", size = "m", showThumbs = true }: {
  item: CoverItem;
  className?: string;
  size?: "s" | "m" | "l";
  showThumbs?: boolean;
}) {
  const kind = item.coverKind;
  const img = kind === "image" ? item.coverUrl : kind === "auto" && showThumbs ? item.thumbUrl : null;
  const cls = `cover cover-${size} ${className}`.trim();
  // a feed's plain-http artwork would mark the whole page "not secure"; every image host we meet serves https
  if (img) return <img className={cls} src={img.replace(/^http:\/\//, "https://")} alt="" loading="lazy" />;
  const style = gradientStyle(item.coverSeed);
  if (kind === "emoji" && item.coverValue) {
    return <div className={cls} style={style} aria-hidden="true"><span className="cover-emoji">{item.coverValue}</span></div>;
  }
  if (kind === "text" && item.coverValue) {
    return <div className={cls} style={style} aria-hidden="true"><span className="cover-text">{item.coverValue}</span></div>;
  }
  return <div className={cls} style={style} aria-hidden="true" />;
}
